import { NgComponentOutlet } from '@angular/common';
import {
  EventEmitter,
  Injector,
  OutputEmitterRef,
  SimpleChanges,
  Type,
  Directive,
  Input,
} from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';

import type { Subscription } from 'rxjs';
import { merge, tap, isObservable } from 'rxjs';

@Directive({
  selector: '[rtComponentOutlet]',
  standalone: true,
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class RtComponentOutlet extends NgComponentOutlet {
  @Input({
    alias: 'rtComponentOutlet',
  })
  public ngComponentOutlet: Type<any> | null = null;
  @Input({
    alias: 'rtComponentOutletInputs',
  })
  public ngComponentOutletInputs?: Record<string, unknown>;
  @Input({
    alias: 'rtComponentOutletInjector',
  })
  public ngComponentOutletInjector?: Injector;
  @Input({
    alias: 'rtComponentOutletContent',
  })
  public ngComponentOutletContent?: any[][];
  @Input({
    alias: 'rtComponentOutletNgModuleFactory',
  })
  public ngComponentOutletNgModule?: Type<any>;
  @Input() public rtComponentOutletOutputs?: Record<string, (arg: any) => void>;

  private outputsSub: Subscription | null = null;

  public ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    if (changes.rtComponentOutletOutputs || changes.rtComponentOutlet) {
      const outputs = this.rtComponentOutletOutputs || {};
      this.outputsSub?.unsubscribe();
      const componentRef = this['_componentRef'];
      if (componentRef) {
        this.outputsSub = merge(
          ...Object.entries(outputs).map(([key, handler]) => {
            const observableOrOutputRef: EventEmitter<any> | OutputEmitterRef<any> =
              this['_componentRef']!.instance[key];
            const observable$ = isObservable(observableOrOutputRef)
              ? observableOrOutputRef
              : outputToObservable(observableOrOutputRef);
            return observable$.pipe(tap(handler));
          }),
        ).subscribe();
      }
    }
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.outputsSub?.unsubscribe();
  }
}
